WiseMetering.Views.ShowSpheraConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/sphera/show',
    title: () => i18next.t('modal.title.integration_configurations.show'),

    edit: function() {
        new WiseMetering.Views.EditSpheraConfiguration({ model: this.model });
    }
});
